import components from '../components';
import MembresController from './membres.controller';
import MembresTemplate from './membres.template.html';

components
  .component('membres', {
    bindings: {},
    controller: MembresController,
    template: MembresTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/membres/membres.component.js